import React from 'react';
import { Link, NavLink } from 'react-router-dom';
import { connect } from 'react-redux';

import { userActions } from '../_actions';

class ContactForm extends React.Component {
    constructor(props) {
        super(props);

        const { user } = this.props;

        this.state = {
            contactFormFields: {
                name: user.first_name == 'Guest' ? '' : user.first_name + ' ' + user.last_name,
                email: user.first_name == 'Guest' ? '' : user.email,
                message: ''
            },
            submitted: false
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleChange(event) {
        const { name, value } = event.target;
        const { contactFormFields } = this.state;
        this.setState({
            contactFormFields: {
                ...contactFormFields,
                [name]: value
            }
        });
    }

    handleSubmit(event) {
        event.preventDefault();

        this.setState({ submitted: true });

        const { contactFormFields } = this.state;
        const { dispatch } = this.props;
        if (contactFormFields.name && contactFormFields.email && this.validateEmail(contactFormFields.email) && contactFormFields.message && contactFormFields.message.length < 300) {
            dispatch(userActions.sendMessage(contactFormFields));
        }
    }

    validateEmail(email) {
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    }

    render() {
        //const { sending } = this.props;
        //const { contactFormFields, submitted } = this.state;
        return (
          <div className='col-md-6 col-md-offset-3'>
            <h2>Contact Fix-a-Drink</h2>
            <p>
              Got a great cocktail that you cannot find on Fix-A-Drink? Have an
              idea on how to make Fix-a-Drink better? Find a bug? Let me know!
            </p>

            <p style={{ fontSize: '160%' }}>
              Email Steve Breese at <strong>sbreese@gmail.com</strong>
            </p>
            <p>I should respond within 24 hours.</p>
          </div>
        )
    }
}

function mapStateToProps(state) {
    const { authentication } = state;
    const { sending } = state.communication;
    const { user } = authentication;
    return {
        user,
        sending
    };
}

const connectedContactForm = connect(mapStateToProps)(ContactForm);
export { connectedContactForm as ContactForm };

/*
              <form name="form" onSubmit={this.handleSubmit}>
                  <div className={'form-group' + (submitted && !contactFormFields.name ? ' has-error' : '')}>
                      <label htmlFor="name">Name</label>
                      <input type="text" className="form-control" name="name" value={contactFormFields.name} onChange={this.handleChange} />
                      {submitted && !contactFormFields.name &&
                      <div className="help-block">Name is required</div>
                      }
                  </div>
                  <div className={'form-group' + (submitted && (!contactFormFields.email || !this.validateEmail(contactFormFields.email)) ? ' has-error' : '')}>
                      <label htmlFor="email">Email</label>
                      <input type="text" className="form-control" name="email" value={contactFormFields.email} onChange={this.handleChange} />
                      {submitted && !contactFormFields.email &&
                      <div className="help-block">Email is required</div>
                      }
                      {submitted && !this.validateEmail(contactFormFields.email) &&
                      <div className="help-block">Email is not valid</div>
                      }
                  </div>
                  <div className={'form-group' + (submitted && (!contactFormFields.message || contactFormFields.message.length > 300) ? ' has-error' : '')}>
                      <label htmlFor="message">Message</label>
                      <textarea className="form-control" name="message" value={contactFormFields.message} onChange={this.handleChange} rows="5" />
                      {submitted && !contactFormFields.message &&
                      <div className="help-block">Message is required</div>
                      }
                      {submitted && contactFormFields.message.length > 300 &&
                      <div className="help-block">Message is too long ({contactFormFields.message.length} characters). There is a 300 character max.</div>
                      }
                  </div>
                  <div className="form-group">
                      <button className="btn btn-primary">Submit</button>
                      {sending &&
                      <img src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==" />
                      }
                  </div>
              </form>
              */


// WEBPACK FOOTER //
// ./src/ContactForm/ContactForm.jsx